(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordionsSection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordionTitles = document.querySelectorAll('.accordion-title');

  // Sab titles ke liye icon span add karo
  accordionTitles.forEach(function(title) {
    const icon = document.createElement('span');
    icon.textContent = '+'; // default icon
    icon.style.fontWeight = 'bold';
    icon.style.marginLeft = '10px';
    title.appendChild(icon);
  });

  // By default pehla accordion open karo
  if (accordionTitles.length > 0) {
    accordionTitles[0].nextElementSibling.style.display = 'block';
    accordionTitles[0].querySelector('span').textContent = '−';
  }

  accordionTitles.forEach(function(title) {
    title.addEventListener('click', function() {
      const content = title.nextElementSibling;

      // Pehle sabhi contents ko close karo
      accordionTitles.forEach(function(otherTitle) {
        if (otherTitle !== title) {
          otherTitle.nextElementSibling.style.display = 'none';
          otherTitle.querySelector('span').textContent = '+';
        }
      });

      // Clicked accordion toggle
      const icon = title.querySelector('span');
      if (content.style.display === 'block') {
        content.style.display = 'none';
        icon.textContent = '+';
      } else {
        content.style.display = 'block';
        icon.textContent = '−';
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
